module.exports = __webpack_public_path__ + "img/2001-Vecernji-List2.2859539b.jpg";